module.exports = __webpack_public_path__ + "img/oxfordshire-logo.d6a29f75.svg";